import { render, staticRenderFns } from "./DocumentInsertionNumber.vue?vue&type=template&id=733a8ba0&"
import script from "./DocumentInsertionNumber.vue?vue&type=script&lang=ts&"
export * from "./DocumentInsertionNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports